import { UI_REGISTER_CONST } from '../../const/ui/ui-register.const'
import ITypes from './registrationSlice.types'

const baseDataForAccordion = {
  totalPrice: 0,
  recipientIds: [],
  recipientsCount: 0,
  totalItemsCount: 0,
  uniqueRecipientCount: 0,
}

const PAY_TAB: ITypes['IRegistrationInitialState']['tabs']['payTab'] = {
  registration: {
    ...baseDataForAccordion,
    totalHorseCount: 0,
    totalMemberCount: 0,
    uniqueHorseCount: 0,
    uniqueMemberCount: 0,
    totalRegistrationCount: 0,
  },
  ticket: baseDataForAccordion,
  fees: baseDataForAccordion,
  governance: baseDataForAccordion,
  grandTotal: {
    registrationTotal: 0,
    feesTotal: 0,
    governanceTotal: 0,
    ticketTotal: 0,
    salesTax: 0,
    totalPrice: 0,
    totalItemsCount: 0,
    amountByPerson: [],
  },
  summary: {
    ...baseDataForAccordion,
    data: [],
    remainingTotalPrice: 0,
    recipientsTotalPrice: 0,
  },
  paperwork: {
    data: [],
    signatoryCount: 0,
  },
}

const TABS: ITypes['IRegistrationInitialState']['tabs'] = {
  feesTab: [],
  ticketTab: [],
  teamTab: [],
  registerTab: [],
  paperworkTab: [],
  payTab: PAY_TAB,
  signTab: {
    eventOwnerIsMinor: false,
    eventOwnerAdded: false,
    showGuardianMessage: false,
  },
}

const DATA: ITypes['IRegistrationInitialState']['data'] = {
  registration: null,
  recipientsInDb: [],
  publishedEventInDb: null,
  ridersTeamMembers: [],
  ridersTeamMembersInDb: [],
  registrationsFees: [],
  registrationsByDay: [],
  registrationsTickets: [],
  filteredPaperworkDocuments: [],
  registrationsByDayInDb: [],
}

const REGISTRATION_INITIAL_STATE: ITypes['IRegistrationInitialState'] = {
  activeStep: 0,
  /** @info `true` specifies that the payment is in progress */
  paying: false,
  activeTab: UI_REGISTER_CONST.TABS.CONFIRMATION,
  loading: false,
  tabs: TABS,
  hasErrors: {
    users: false,
    horses: false,
  },
  data: DATA,
}

const REGISTRATION_SLICE_CONSTS = {
  INITIAL_STATE: REGISTRATION_INITIAL_STATE,
}

export default REGISTRATION_SLICE_CONSTS
